import React, {useEffect, useState} from "react";
import {
  CommonMFE,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import { ContainerDiv } from "./App.style";
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

import { Helpers } from "@tpd-web-common-libs/nodejs-library";

import RiepilogoPreventivoSticky from "./riepilogo-preventivo-sticky/RiepilogoPreventivoSticky";

const App = (props: CommonMFE.Types.TRemoteProps) => {
  const { __host__, config, isEditMode, id: containerID, __mfeName__ } = props;

  return (
    <ContainerDiv>
      <RiepilogoPreventivoSticky
          __host__={__host__}
          id={CommonMFE.generateID(
              containerID,
              `${MFE_NAMES.tpdRiepilogoPreventivoStickyWidget}`
          )}
          isEditMode={isEditMode}
          config={config.tpdRiepilogoPreventivoStickyWidget?.config ?? config}
      ></RiepilogoPreventivoSticky>
    </ContainerDiv>
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
